import Login from '@/views/experience/login/index.vue'

export const experienceRouters = [
    {
        path: '/experience/login',
        name: 'experience-login',
        component: Login,
    },
    { // 财税体验实操
        path: '/experience/cssc',
        name: 'experience-cssc',
        component: () => import('@/views/experience/cssc/index.vue'),
    },
]